import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { User, UserAccessLevelType } from '../entities/user.model';

@Injectable()
export class UserService {
    public RequestResult: boolean = true;
    private ErrorResponse: any;
    public user = new Subject<User>();

    constructor(private _http: Http) {
        this.loadUserDetails().subscribe(response => {
            this.user.next(response);
        });
    }

    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    public getCurrentUser(): Observable<User> {
        return this.user.asObservable();
    }

    /*
        Returns a user object for the currently signed in user. 
    */
    public loadUserDetails(): Observable<User> {
        let params: URLSearchParams = new URLSearchParams();
        return this._http.get("api/user/me").share().map(
            (response: Response) => <User>response.json()).catch(this.handleError);
    }

  
}